import SenderImage from './SenderImage';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import Message from 'owa-service/lib/contract/Message';
import * as React from 'react';

export interface SenderImageWrapperProps {
    message: Message;
    displaySelf: boolean;
    style?: string;
    isUnauthenticatedSender?: boolean;
    size?: PersonaSize;
    showPresence?: boolean;
    displayPersonaHighlightRing?: boolean;
}

const SenderImageWrapper = (props: SenderImageWrapperProps) => {
    const { message, ...other } = props;
    return <SenderImage sender={message.From ? message.From : message.Sender} {...other} />;
};

export default SenderImageWrapper;
